import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { DecisionMaker } from './components/DecisionMaker';
import { Description } from './components/Description';
import { Media } from './components/Media';
import { Title } from './components/Title';

export const PetitionContent: React.FC = () => {
	return (
		<>
			<Text variant="heading" size="x-small" className="lowercase first-letter:uppercase" as="p">
				<Translate value="corgi.petition.edit.petition_content.heading" />
			</Text>
			<Flex sx={{ flexDirection: 'column', gap: 26 }}>
				<Title />
				<Description />
				<Media />
			</Flex>
			<div className="mt-14">
				<DecisionMaker />
			</div>
		</>
	);
};
